<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="756px"
    @close="$router.replace('/roles')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="role"
      :rules="rules"
      ref="roleForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
      >
        <el-input
          v-model="role.name"
        />
      </el-form-item>
      <el-transfer
        v-model="role.permissions"
        filterable
        :data="permissions"
        :titles="['Összes jogosultság', 'Kiválasztott jogosultságok']"
      />
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/roles')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'roleId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      permissions: [],
      role: {
        permissions: [],
      },
      rules: {
        name: [
          { required: true, message: 'Név megadása kötelező', trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    title() {
      if (this.type === 'add') {
        return 'Új jogkör';
      } else if (this.type === 'update') {
        return 'Jogkör módosítása';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadás';
      } else if (this.type === 'update') {
        return 'Módosítás';
      }
    },
  },
  methods: {
    async add() {
      this.$refs['roleForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;

          try {
            if (this.type === 'add') {
              await axios.post('api/roles', this.role);
            } else if (this.type === 'update') {
              await axios.put('api/roles', this.role);
            }
            this.$store.dispatch('role/fetchAll');
            this.$router.replace('/roles');
          } catch (e) {
          }

          this.buttonLoading = false;
        }
      });
    }
  },
  async mounted() {
    this.loading = true;
    if (this.roleId) {
      this.role = await axios.get(`api/roles/${this.roleId}`);
    }
    const permissions = await axios.get('api/permissions');
    this.permissions = permissions.map(permission => ({
      key: permission.id,
      label: permission.name,
    }));
    this.role.permissions = this.role.permissions.map(permission => permission.id);
    this.loading = false;
  },
}
</script>

<style>
  .el-transfer-panel {
    width: 300px;
  }

  .el-transfer .el-button{
    display: block;
    margin-left: 0px;
    margin-right: 0px;
  }
</style>
